import { render } from "./NutritionalPropertiesList.vue?vue&type=template&id=7d611dba&scoped=true"
import script from "./NutritionalPropertiesList.vue?vue&type=script&lang=js"
export * from "./NutritionalPropertiesList.vue?vue&type=script&lang=js"

import "./NutritionalPropertiesList.vue?vue&type=style&index=0&id=7d611dba&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d611dba"],['__file',"resources/js/modules/labelinsight-products/components/NutritionalPropertiesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d611dba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d611dba', __exports__)) {
    api.reload('7d611dba', __exports__)
  }
  
  module.hot.accept("./NutritionalPropertiesList.vue?vue&type=template&id=7d611dba&scoped=true", () => {
    api.rerender('7d611dba', render)
  })

}


export default __exports__